/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_TIME: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.VendingMachinePage.get-shelves',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_SHELVES' },
      },
    },
    GET_SHELVES: {
      invoke: {
        id: 'getShelves',
        src: 'getShelves',
        onDone: {
          target: 'RENDER_SHELVES',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_SHELVES_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_SHELVES: {
      on: {
        TRIGGER_REFRESH_FOR_GET_SHELVES: {
          target: 'GET_SHELVES',
        },
      },
    },
    RENDER_SHELVES_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
